import React from 'react';
import { Bot, Lightbulb, Trash2 } from 'lucide-react';
import clsx from 'clsx';

interface AIHubHeaderProps {
    isDark: boolean;
    showSidebar: boolean;
    setShowSidebar: (show: boolean) => void;
    clearChat: () => void;
}

export const AIHubHeader: React.FC<AIHubHeaderProps> = ({
    isDark,
    showSidebar,
    setShowSidebar,
    clearChat
}) => {
    return (
        <div className="flex justify-between items-center mb-4">
            <div>
                <h1 className={clsx(
                    'text-2xl font-bold flex items-center gap-2',
                    isDark ? 'text-white' : 'text-slate-800'
                )}>
                    <Bot className="text-purple-500" />
                    Intelligence Hub
                </h1>
                <p className={clsx('text-sm', isDark ? 'text-slate-400' : 'text-slate-500')}>
                    Advanced Reliability Engineering AI Workspace
                </p>
            </div>
            <div className="flex gap-2">
                <button
                    onClick={() => setShowSidebar(!showSidebar)}
                    className={clsx(
                        'flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg border transition-colors',
                        isDark
                            ? 'border-purple-700 text-purple-400 hover:bg-purple-900/30'
                            : 'border-purple-200 text-purple-600 hover:bg-purple-50'
                    )}
                >
                    <Lightbulb size={16} />
                    {showSidebar ? 'Hide' : 'Show'} Toolkit
                </button>
                <button
                    onClick={clearChat}
                    className={clsx(
                        'flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg border transition-colors',
                        isDark
                            ? 'border-red-800 text-red-400 hover:bg-red-900/30'
                            : 'border-red-200 text-red-500 hover:bg-red-50'
                    )}
                >
                    <Trash2 size={16} />
                    Clear
                </button>
            </div>
        </div>
    );
};
